import {Component, OnInit} from '@angular/core';
import {select, Store} from '@ngrx/store';
import {INotification, selectNotificationsViewModel} from '@store/notifications';
import {updateNotification} from '@store/notifications/actions';
import {HtmlSanitizerService} from '@core/services/html-sanitizer.service';
import {SafeHtml} from '@angular/platform-browser';

@Component({
    selector: 'oct-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss'],
})

export class NotificationsComponent implements OnInit {
    notifications: INotification[] = [];
    hideBadge = true;
    unreadCount = 0;

    private readonly documentationUrl = 'https://docs.cloudera.com/octopai/latest/index.html';
    private readonly supportCaseUrl = 'https://lighthouse.cloudera.com/s/cases';

    constructor(
        private store: Store<any>,
        private htmlSanitizer: HtmlSanitizerService,
    ) {
    }

    ngOnInit(): void {
        this.store
            .pipe(select(selectNotificationsViewModel))
            .subscribe((vm) => {
                this.notifications = vm.notifications;
                this.unreadCount = vm.unreadCount;
                this.hideBadge = vm.hideBadge;
            });
    }

    onOpen() {
        this.hideBadge = true;
        const ids = this.notifications.map(n => n.id);
        ids.forEach(id => this.store.dispatch(updateNotification({id, payload: {isRead: true}})));
    }

    formatMessage(message: string): SafeHtml {
        if (!message) {
            return '';
        }

        const sanitizedMessage = this.htmlSanitizer.stripAllHtml(message);
        const formattedMessage = sanitizedMessage
            .replace(
                /Cloudera Documentation Center/g,
                `<a href="${this.documentationUrl}" target="_blank" rel="noopener noreferrer">Cloudera Documentation Center</a>`,
            )
            .replace(
                /open a Support Case/g,
                `<a href="${this.supportCaseUrl}" target="_blank" rel="noopener noreferrer">open a Support Case</a>`,
            );

        return this.htmlSanitizer.sanitizeHtml(formattedMessage);
    }
}
